<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<circle style="fill:#FFDA44;" cx="256" cy="256" r="256"/>
<g>
	<path style="fill:#338AF3;" d="M155.826,166.957h340.25C459.906,69.472,366.07,0,256,0C185.306,0,121.313,28.659,74.989,74.989
		L155.826,166.957z"/>
	<path style="fill:#338AF3;" d="M155.826,345.043h340.25C459.906,442.528,366.07,512,256,512
		c-70.694,0-134.687-28.659-181.011-74.989L155.826,345.043z"/>
</g>
<path d="M74.98,74.98c-99.974,99.974-99.974,262.065,0,362.04C116.293,395.707,156.026,355.974,256,256L74.98,74.98z"/>
</svg>